import type { ColumnDef } from '@tanstack/vue-table'
import TableHeaderTooltip from '~/components/TableHeaderTooltip.vue'
import EditGhgEmissionFactorReviewModal from '~/components/EditGhgEmissionFactorReviewModal.vue'

export const createColumns = (
  categoryId: number,
  refresh: () => void,
): ColumnDef<GhgEmissionFactorMatchingGroup>[] => [
  {
    accessorKey: 'item_name',
    id: 'item_name',
    size: 250,
    header: () => h('span', { class: 'text-sm text-slate-800 font-semibold capitalize' }, 'item description'),
    cell: ({ row }) => h('div', { class: 'text-sm no-localize-translate' }, row.original.item_name),
  },
  {
    accessorKey: 'unit',
    id: 'unit',
    size: 150,
    header: () => h('span', { class: 'text-sm text-slate-800 font-semibold capitalize' }, 'input unit'),
    cell: ({ row }) => h('div', { class: 'text-sm whitespace-nowrap no-localize-translate' }, row.original.unit),
  },
  {
    accessorKey: 'asset',
    id: 'asset',
    size: 180,
    header: () => h('span', { class: 'text-sm text-slate-800 font-semibold capitalize' }, 'asset'),
    cell: ({ row }) => h('div', { class: 'text-sm' }, row.original.asset),
  },
  {
    accessorKey: 'total_datapoints',
    id: 'total_datapoints',
    size: 180,
    header: () => h('span', { class: 'text-sm text-slate-800 font-semibold' }, 'Number of datapoints'),
    cell: ({ row }) => h('div', { class: 'text-sm' }, row.original.total_datapoints),
  },
  {
    accessorKey: 'selected_emission_factor',
    id: 'emission_factor',
    size: 280,
    header: () => h('div', { class: 'flex items-center gap-1' }, [
      h('span', { class: 'text-sm text-slate-800 font-semibold capitalize' }, 'emission factor'),
      h(TableHeaderTooltip, {
        title: 'Emission factor (EF) is a coefficient to convert activity data into GHG emission. An orange outline indicates an EF is recommended by our AI engine as it has not been preconfigured in the platform.',
        position: 'left',
      }),
    ]),
    cell: ({ row }) => {
      const { selected_emission_factor } = row.original
      const isPreconfigured = selected_emission_factor?.source_type === 'preconfigured'

      return isPreconfigured
        ? h('div', {
          class: 'text-theme-header-primary truncate max-w-[20vw] no-localize-translate',
          title: selected_emission_factor.emission_factor,
        }, selected_emission_factor.emission_factor)
        : h(EditGhgEmissionFactorReviewModal, {
          group: row.original,
          category: categoryId,
          onEfGroupEdited: refresh,
        })
    },
  },
  {
    accessorKey: 'emission_factor_value',
    id: 'emission_factor_value',
    size: 200,
    header: () => h('div', { class: 'flex items-center gap-1 justify-between overflow-visible' }, [
      h('span', { class: 'text-sm text-slate-800 font-semibold capitalize' }, 'Emission Factor Value'),
    ]),
    cell: ({ row }) => {
      const value = row.original.selected_emission_factor?.derived_ef_value ? Number(row.original.selected_emission_factor.derived_ef_value).toFixed(4) : ''
      const unit = row.original.selected_emission_factor?.unit || ''

      return h('div', { class: 'text-sm no-localize-translate' }, `${value}${unit}`)
    },
  },
]
